import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';

import { ReplaySubject } from 'rxjs';

import { ErrorPagesMessage } from '@modules/layout/constants';

@Component({
  selector: 'mg-layout-access-denied',
  templateUrl: './layout-access-denied.component.html',
  styleUrls: ['./layout-access-denied.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LayoutAccessDeniedComponent implements OnDestroy {
  // Constants
  public readonly MSG = ErrorPagesMessage;

  // Cleanup
  private readonly _destroyedSubject = new ReplaySubject<void>(1);

  /** Component Constructor */
  constructor() {}

  ngOnDestroy(): void {
    this._destroyedSubject.next();
    this._destroyedSubject.complete();
  }
}
